<main>
    <div class="content">
        <div class="image-container">
            <img [src]="baseApiUrl + '/uploads/images/what_new/what_new/what_new_1.jpg'" alt="" class="main-image">
            <p class="image-text">{{ "what_new.What's New" | translate }}</p>
        </div>
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav">
                    <li class="nav-item active">
                        <a class="nav-link" href="/what-new/1">{{ "what_new.What's New" | translate }}</a>
                    </li>      
                    <li class="nav-item">
                        <a class="nav-link" href="/gallery">{{ 'what_new.Gallery' | translate }}</a>
                    </li>     
                </ul>
            </div>
        </nav>
        <div class="what-new">
            <div *ngIf="currentPage == 1">
                <div *ngFor="let whatnew of whatNew1; let i = index">
                    <div [class]="whatnew.class">
                        <div *ngIf="i % 2 === 1">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-12" *ngIf="currentLanguage === 'en'">
                                    <h2>{{ whatnew.title }}</h2>
                                    <p>{{ whatnew.desc }}</p>
                                    <small>{{ whatnew.date }}</small>
                                    <div class="read-more">
                                        <a class="btn btn-primary" [routerLink]="['/what-new/detail', whatnew.url]"  routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{ 'what_new.Read More' | translate}}</a>
                                    </div>
                                </div>
                                 <div class="col-lg-6 col-md-6 col-sm-6 col-12" *ngIf="currentLanguage === 'kh'">
                                    <h2>{{ whatnew.titleKh }}</h2>
                                    <p>{{ whatnew.descKh }}</p>
                                    <small>{{ whatnew.date }}</small>
                                    <div class="read-more">
                                        <a class="btn btn-primary" [routerLink]="['/what-new/detail', whatnew.url]"  routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{ 'what_new.Read More' | translate}}</a>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                    <img [src]="whatnew.img" alt="">
                                </div>
                            </div>
                        </div>
                        <div *ngIf="i % 2 === 0">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                    <img [src]="whatnew.img" alt="">
                                </div>
                            
                                <div class="col-lg-6 col-md-6 col-sm-6 col-12" *ngIf="currentLanguage === 'en'">
                                    <h2>{{ whatnew.title }}</h2>
                                    <p>{{ whatnew.desc }}</p>
                                    <small>{{ whatnew.date }}</small>
                                    <div class="read-more">
                                        <a class="btn btn-primary"[routerLink]="['/what-new/detail', whatnew.url]"  routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{ 'what_new.Read More' | translate}}</a>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 col-12" *ngIf="currentLanguage === 'kh'">
                                    <h2>{{ whatnew.titleKh }}</h2>
                                    <p>{{ whatnew.descKh }}</p>
                                    <small>{{ whatnew.date }}</small>
                                    <div class="read-more">
                                        <a class="btn btn-primary" [routerLink]="['/what-new/detail', whatnew.url]"  routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{ 'what_new.Read More' | translate}}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="currentPage == 2">
                <div *ngFor="let whatnew of whatNew2; let i = index">
                    <div [class]="whatnew.class">
                        <div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-12" *ngIf="currentLanguage === 'en'">
                                    <h2>{{ whatnew.title }}</h2>
                                    <p>{{ whatnew.desc }}</p>
                                    <small>{{ whatnew.date }}</small>
                                    <div class="read-more">
                                        <a class="btn btn-primary" [routerLink]="['/what-new/detail', whatnew.url]"  routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{ 'what_new.Read More' | translate}}</a>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 col-12" *ngIf="currentLanguage === 'kh'">
                                    <h2>{{ whatnew.titleKh }}</h2>
                                    <p>{{ whatnew.descKh }}</p>
                                    <small>{{ whatnew.date }}</small>
                                    <div class="read-more">
                                        <a class="btn btn-primary" [routerLink]="['/what-new/detail', whatnew.url]"  routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{ 'what_new.Read More' | translate}}</a>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                    <img [src]="whatnew.img" alt="">
                                </div>
                            </div>
                        </div>
                        <div *ngIf="i % 2 === 0">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                    <img [src]="whatnew.img" alt="">
                                </div>
                            
                                <div class="col-lg-6 col-md-6 col-sm-6 col-12" *ngIf="currentLanguage === 'en'">
                                    <h2>{{ whatnew.title }}</h2>
                                    <p>{{ whatnew.desc }}</p>
                                    <small>{{ whatnew.date }}</small>
                                    <div class="read-more">
                                        <a class="btn btn-primary" [routerLink]="['/what-new/detail', whatnew.url]"  routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{ 'what_new.Read More' | translate}}</a>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 col-12" *ngIf="currentLanguage === 'kh'">
                                    <h2>{{ whatnew.titleKh }}</h2>
                                    <p>{{ whatnew.descKh }}</p>
                                    <small>{{ whatnew.date }}</small>
                                    <div class="read-more">
                                        <a class="btn btn-primary" [routerLink]="['/what-new/detail', whatnew.url]"  routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{ 'what_new.Read More' | translate}}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pagination">
            <div class="row justify-content-center">
                <div class="col text-center">
                    <a (click)="previousPage()" [ngClass]="{disabled: isPreviousDisabled()}"><img style="width: auto; height: 35px;" [src]="page == 1 ? activePrevious : inactivePrevious" alt=""></a>
                </div>
                <div class="col text-center">
                    <img [src]="page == 1 ? activePaginateIcon : inactivePaginateIcon" alt="">
                </div>
                <div class="col text-center">
                    <img [src]="page == 2 ? activePaginateIcon : inactivePaginateIcon" alt="">
                </div>
                <div class="col text-center">
                    <a (click)="nextPage()" [ngClass]="{disabled: isNextDisabled()}"><img style="width: auto; height: 35px;" [src]="page == 2 ? activeNext : inactiveNext" alt=""></a>
                </div>
            </div>
        </div>
        <div class="bottom-content-poster">
            <img [src]="baseApiUrl + '/uploads/images/customer_service/customer_service_1.jpg'" alt="">
            <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
        </div>
    </div>
</main>
